import {dom, library} from "@fortawesome/fontawesome-svg-core";
import {fas} from "@fortawesome/free-solid-svg-icons";

library.add(fas);

// This will kick of the initial replacement of i to svg tags and configure a MutationObserver
// needed for Leaflet extra marker
dom.watch();